import { colors } from "commonConstants";
import CardContainer from "components/CardContainer";
import ProductDescription from "components/ProductDescription";
import Navigation from "root/Navigation";
import ErrorPage from "./errorPage";

function Mainpage({ accessDenied = true }) {
  if (accessDenied)
    return (
      <>
        <Navigation accessDenied={{ accessDenied }} />
        <ErrorPage />
      </>
    );
  return (
    <>
      <Navigation />
      <ProductDescription />
      <div style={{ flex: "1 1 auto", backgroundColor: colors.blackish }} />
      <CardContainer />
      <div style={{ flex: "1 0 2rem", backgroundColor: colors.whiteish }} />
    </>
  );
}

export default Mainpage;
